import { render, staticRenderFns } from "./publicMenu.vue?vue&type=template&id=5fa433c6&scoped=true&"
import script from "./publicMenu.vue?vue&type=script&lang=js&"
export * from "./publicMenu.vue?vue&type=script&lang=js&"
import style0 from "./publicMenu.vue?vue&type=style&index=0&id=5fa433c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa433c6",
  null
  
)

export default component.exports